import { useState } from "react";
import UserLoader from "src/Dashboard/UserLoader";
import { Notification } from "src/handler/accountHandler";

const AdminNotification = () => {
    const [template, setTemplate] = useState("");
    const [message, setMessage] = useState("");
    const [loader, setLoader] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        const payload = {
            template: parseInt(template), // template ID as number
            message: message,
        };

        try {
            const response = await Notification(payload)
            if (response.statusCode === 200) {
                alert("Notification sent successfully!");
            } else {
                alert("Failed to send notification.");
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error("Error:", error);
            alert("Something went wrong.");
        }
            setLoader(false);
    };

    return (
        <>
            {
                loader ?
                    <>
                    <UserLoader />
                    </> :
                    <div style={{ maxWidth: "600px", margin: "40px auto", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                        <h2 style={{ textAlign: "center", color: "#0056b3" }}>Admin Notification</h2>
                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: "20px" }}>
                                <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>Select Template</label>
                                <select
                                    value={template}
                                    onChange={(e) => setTemplate(e.target.value)}
                                    style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                                    required
                                >
                                    <option value="">-- Choose Template --</option>
                                    <option value="1">Testing Email</option>
                                    <option value="2">Festival Greeting</option>
                                    <option value="3">System Update</option>
                                    <option value="4">Educational Support</option>
                                </select>
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>Message</label>
                                <textarea
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                                    placeholder="Enter your notification message..."
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                style={{
                                    width: "100%",
                                    padding: "12px",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                }}
                            >
                                Send Notification
                            </button>
                        </form>
                    </div>
            }
        </>
    );
};

export default AdminNotification;
